angular.module('Itao.IndicatorMap').directive('setTable', function (d3, mapConfig, IndicatorSetHandling, UtilityService, $compile) {
  'use strict';

  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;

  /**
   *
   * @param listOrIndicator
   * @returns {boolean}
   */
  function isList(listOrIndicator) {
    return listOrIndicator.hasOwnProperty('indicators');
  }

  /**
   *
   * @param sortedListsAndIndicators
   * @param setHasLists
   * @param numberOfIndicators
   * @returns {string}
   */
  function prepareTableHead(sortedListsAndIndicators, setHasLists, numberOfIndicators) {
    var defaultRowSpan = setHasLists ? 2 : 1;
    var defaultWidth = 90/numberOfIndicators;
    var odd = false;
    var tdClass = [];
    var thClasses = '';
    var headHtml = '<thead><tr><th width="10%" rowspan="'+ defaultRowSpan +'"></th>'+sortedListsAndIndicators.map(function(listOrIndicator, key) {
      tdClass = [];
      if(isList(listOrIndicator)) {
        odd = !odd;
        listOrIndicator.odd = odd;
        tdClass.push("line-left");
        tdClass.push("line-right");
        tdClass.push(odd ? 'set-odd' : 'set-even');
        thClasses = ' class="'+tdClass.join(' ')+'"';
      }
      if(!listOrIndicator.hasData) return;
      var filteredListIndicators = null;
      if(isList(listOrIndicator)) {
        filteredListIndicators = listOrIndicator.indicators.filter(function(ind){return ind.hasData;});
      }
      var width = filteredListIndicators ? filteredListIndicators.length * defaultWidth : defaultWidth;
      return '<th'+thClasses+' width="'+width+'%" rowspan="'+ (isList(listOrIndicator) ? 1 : defaultRowSpan) + '" colspan="' + (isList(listOrIndicator) ? filteredListIndicators.length : 1) + '">' +(listOrIndicator.name || listOrIndicator.title) + '</th>';
    }).join('') + '</tr>';
    if(setHasLists) {
      headHtml += '<tr>' + sortedListsAndIndicators
        .filter(isList)
        .map(function(list){
          return list.indicators.map(function(indicator, listIndex) {
            var tdClass = [];
            if(listIndex === 0) {
              tdClass.push("line-left");
            }
            if(listIndex === list.indicators.length-1) {
              tdClass.push("line-right");
            }
            tdClass.push(list.odd ? 'set-odd' : 'set-even');
            var thClasses = ' class="'+tdClass.join(' ')+'"';
            return indicator.hasData ? '<th'+thClasses+' width="'+defaultWidth+'%">' + indicator.name + '</th>' : '';
          // return list.indicators.map(function(indicator) {
          //   return indicator.hasData ? '<th width="'+defaultWidth+'%">' + indicator.name + '</th>' : '';
          })
        }).join('') + '</tr>';
    }
    headHtml += '</thead>';

    return headHtml;
  }

  /**
   *
   * @param layer
   * @param indicators
   * @param district
   * @param colorSets
   * @param selectedIndicator
   * @returns {string}
   */
  function bodyRowFromDistrict(layer, indicators, district, colorSets, selectedIndicator) {
    var isNumericValue = false;
    var tdCssClassAttribute = '';
    var odd = false;
    var decimals = false;
    var legend = false;

    return '<tr><td>'+district.key+'</td>' + indicators.map(function(indicator, key){
      var value = '-';
      var tooltip = '';
      var tdClass = [];

      if(indicator.type && indicator.list) {
        if((indicators[key-1] && indicators[key-1].list != indicator.list) || (indicator.list && !indicators[key-1])) {
          tdClass.push("line-left");
          odd = !odd;
        }
        if((indicators[key+1] && indicators[key+1].list != indicator.list) || (!indicators[key+1] && indicator.list)) {
          tdClass.push("line-right");
        }
      }
      tdClass.push(odd ? 'set-odd' : 'set-even');

      // has Legend
      if(layer.legend && layer.legend[selectedIndicator.uid] != null && layer.legend[selectedIndicator.uid].map != null) {
        legend = layer.legend[selectedIndicator.uid].map;
      }

      if(indicator.categorical) {
        // use icon as value
        if(legend && layer[district.uid]) {
          // icon plus tooltip
          if(layer[district.uid][indicator.uid] != null ) {
            value = '<span style="display: block; text-align: center; height:16px;">' + UtilityService.iconSvg(UtilityService.scaleForValue(legend.scales, colorSets[legend.colorSet], layer[district.uid][indicator.uid])) + '</span>';
          } else {
            if(legend.hasNoValueText !== '') {
              value = '<span style="display: block; text-align: center; height:16px;">' + UtilityService.iconSvg({icon:'no-value'}) + '</span>';
            } else {
              value = '<span style="display: block; text-align: center; height:16px;">-</span>';
            }
          }
          if(layer.descriptions[district.uid][indicator.uid]) {
            tooltip = layer.descriptions[district.uid][indicator.uid];
          }
        } else {
          // direct value
          if(layer.descriptions[district.uid][indicator.uid]) {
            value = layer.descriptions[district.uid][indicator.uid];
          }
        }
      } else {

        // decimals
        if (legend && legend.decimals && legend.decimals !== 0) {
          decimals = legend.decimals;
        } else {
          decimals = indicator.unit === '%' ? mapConfig.relativeIndicatorsDecimalPlaces : mapConfig.absoluteIndicatorsDecimalPlaces;
        }

        // use normal values
        if(layer[district.uid][indicator.uid] != null) {
          isNumericValue = true;
          tdClass.push("numeric");
          value = ((indicator.unit === '%') ? (germanNumberFormat('.'+decimals+'f')(+layer[district.uid][indicator.uid])/* + '%' */) : (germanNumberFormat(',.'+decimals+'f')(+layer[district.uid][indicator.uid])));
          // wrap numeric value
          value = "<span class='centered-number'>"+value+"</span>";
          if(layer.descriptions[district.uid][indicator.uid]) {
            tooltip = layer.descriptions[district.uid][indicator.uid];
          }
        } else if(layer.descriptions[district.uid][indicator.uid] && layer.descriptions[district.uid][indicator.uid].length > 0) {
            value = layer.descriptions[district.uid][indicator.uid];
            if(value.length < 7) { //
              value = "<span class='centered-number'>"+value+"</span>";
            }
        } else {
          tdClass.push("numeric"); // value = "-" is also numeric
          value = "<span class='centered-number'>-</span>";
        }
      }
      if(tdClass.length) {
        tdCssClassAttribute = ' class="'+tdClass.join(' ')+'"';
      }
      return '<td'+tdCssClassAttribute+'><div tooltip-append-to-body="true" uib-tooltip-html="\'' + ((tooltip != null) ? tooltip : '') +  '\'">' + value + '</div></td>';
    }) + '</tr>';
  }

  /**
   * @param layer
   * @param indicators
   * @param districts
   * @param colorSets
   */
  function prepareTableBody(layer, indicators, districts, colorSets) {
    var selectedIndicator = indicators.filter(function(indicator){return indicator.isDefault;})[0];
    return districts.map(function(district) {
      return bodyRowFromDistrict(layer, indicators, district, colorSets, selectedIndicator);
    });
  }

  /**
   * @param indicators
   */
  function prepareUnitRow(indicators) {
    var filteredIndicators = indicators.filter(function(indicator){
      return indicator.hasData;
    });

    var rowTDs = '<td></td>';
    var colSpan = 1;
    filteredIndicators.forEach(function (indicator, index) {
      if (filteredIndicators[index+1] && indicator.unit === filteredIndicators[index+1].unit) {
        colSpan++;
      } else {
        var unitHead = "";
        if (indicator.unit === "%") {
          unitHead = 'Anteil in %';
        } else {
          unitHead = 'Anzahl';
        }
        rowTDs += '<td colspan="' + colSpan + '">' + unitHead + '</td>';
        colSpan = 1;
      }
    });
    return '<tr class="unit-table-row">'+rowTDs+'</tr>';
  }

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'setTable.html',
    scope: {
      selectedIndicatorSet: '=',
      layer: '=',
      disabledDistrictKeys: '=',
      colorSets: '=',
      config: '=',
      exportData: '='
    },
    link: function (scope, element) {
      var sortedListsAndIndicators;
      var filterEmptyIndicators = function(indicator){
        if(indicator.class !== 'indicator') {
          var setHasData = false;
          indicator.indicators.map(hasData);
          indicator.indicators.forEach(function (subIndicator){
            if(subIndicator.hasData) setHasData = true;
          });
          indicator.hasData = setHasData;
        }
      };

      var hasData = function(indicator) {
        if(indicator.class === 'indicator') {
          indicator.hasData = false;
          angular.forEach(scope.layer.districts, function(district){
            if(scope.layer[district.uid][indicator.uid] || scope.layer.descriptions[district.uid][indicator.uid]) indicator.hasData = true;
          });
        }
      };

      function rerender() {
        if(scope.layer.districts && Object.keys(scope.layer.districts).length === scope.disabledDistrictKeys.length) {
          return null;
        }
        if(scope.selectedIndicatorSet != null && scope.layer != null && scope.disabledDistrictKeys != null && scope.colorSets != null) {
          sortedListsAndIndicators = IndicatorSetHandling.sortIndicatorsAndLists(scope.selectedIndicatorSet);

          var setHasLists = angular.isArray(scope.selectedIndicatorSet.lists) && scope.selectedIndicatorSet.lists.length > 0;
          if(setHasLists) {
            sortedListsAndIndicators.map(filterEmptyIndicators);
          }
          sortedListsAndIndicators.map(hasData);

          var sortedIndicators = IndicatorSetHandling.sortIndicatorsAndListsFlat(scope.selectedIndicatorSet);
          var indicatorsWithData = sortedIndicators.filter(function(indicator){
            return indicator.hasData;
          });

          var head = prepareTableHead(sortedListsAndIndicators, setHasLists, indicatorsWithData.length);
          var districts = Object.keys(scope.layer.districts).map(function(districtUid){
            return scope.layer.districts[districtUid];
          }).filter(function(district) {
            return scope.disabledDistrictKeys.indexOf(district.key) === -1;
          });
          var unitRow = '';
          if(!jQuery('#communeUserData').data('hide-unit-row')) {
            unitRow = prepareUnitRow(indicatorsWithData);
          }

          var body = prepareTableBody(scope.layer, indicatorsWithData, districts, scope.colorSets.reduce(function(acc, colorSet){
            acc[colorSet.uid] = colorSet;
            return acc;
          }, {}));
          element.find('table').html(head + unitRow + body);
          $compile(element.find('table').contents())(scope);

          scope.exportData = getTableExportData(scope.layer, indicatorsWithData, districts);
        }
      }

      var getTableExportData = function(layer ,indicators, districts) {
        var data = [];
        var indicatorValues = [];
        indicatorValues.push("");
        indicators.forEach(function(indicator) {
          indicatorValues.push(indicator.name);
        });
        data.push(indicatorValues);
        districts.forEach(function(district) {
          var districtValues = [];
          districtValues.push(district.key);
          indicators.forEach(function(indicator){
            var value;
            if(layer[district.uid][indicator.uid] != null) {
              value = ((indicator.unit === '%') ? (germanNumberFormat('.'+mapConfig.relativeIndicatorsDecimalPlaces+'f')(+layer[district.uid][indicator.uid])/* + '%' */) : (germanNumberFormat(',.'+mapConfig.absoluteIndicatorsDecimalPlaces+'f')(+layer[district.uid][indicator.uid])));
            } else if(layer.descriptions[district.uid][indicator.uid] != null) {
              value = layer.descriptions[district.uid][indicator.uid].replace(/<(?:.|\n)*?>/gm, '');
            } else {
              value = "";
            }

            districtValues.push(value);
          });
          data.push(districtValues)
        });

        return data;
      };

      var selectedIndicatorSetWatcher = scope.$watch('selectedIndicatorSet', rerender, true);
      var disabledDistrictKeysWatcher = scope.$watchCollection('disabledDistrictKeys', rerender);
      var colorSetsWatcher = scope.$watchCollection('colorSets', rerender);
      var layerWatcher = scope.$watch('layer', rerender, true);

      element.on('$destroy', function () {
        selectedIndicatorSetWatcher();
        disabledDistrictKeysWatcher();
        layerWatcher();
        colorSetsWatcher();
      });
    }
  };
});
